import { gql } from '@apollo/client';

const PHYSICIANS_QUERY = gql`
  query physicians($filter: PhysicianFilter, $limit: Int) {
    physicians(filter: $filter, limit: $limit) {
      id
      firstName
      lastName
      contact {
        phone1
        nightPhone
        fax
      }
      email
      canLogin
      npi
    }
  }
`;

export default PHYSICIANS_QUERY;
